define(["./mapsModule", "../arrays/arrays", "lodash"], function (mapsModule, arrays, _) {
    "use strict";

    /**
     * @ngdoc service
     * @name mapsModule.mapsPathService
     * @description
     * Serviço que recebe uma rota e processa um caminho a partir de uma variação.
     * **Atenção:** Serão adicionadas propriedades nas rotas.
     * */
    return mapsModule.service("mapsPathService", ["$http", "$q", "mapsPathServiceUrl", function ($http, $q, mapsPathServiceUrl) {
        var routePathUrl = mapsPathServiceUrl.getRoutePathUrl();

        
        return function (route) {
            var positions = _.map(route.stops, "address.geographicInfo");
            return (function retry(positions) {
                return routePath(positions, route.pathProviderVariation, route.country, route.pathProviderType)
                    .catch(function (error) {
                        if (positions.length === 2) {
                            return positions;
                        } else if (isRouteNotFound(error) && positions.length > 2) {
                            return $q.all([
                                retry(positions.slice(0, (positions.length + 1) / 2)),
                                retry(positions.slice(positions.length / 2)),
                            ]).then(function (route1, route2) {
                                return route1.concat(route2);
                            });
                        } else {
                            return $q.reject(error);
                        }
                    });
            })(positions)
                .then(function (routeResult) {
                    route.results = [{routes: [routeResult]}];
                    return route;
                });
        };

        function isRouteNotFound(error) {
            return error.status === 422;
        }

        function routePath(positions, variation, country, pathProviderType) {
            return $http.post(routePathUrl, positions, {
                params: {
                    variation: variation,
                    country: country,
                    pathProviderType: pathProviderType
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }]);
});